import styled from "styled-components";

import theme from "./theme";

export const Form = styled.form({
  display: "flex",
  flexDirection: "column",
  width: "90%",
  maxWidth: "1200px",
  backgroundColor: theme.color.white,
  boxShadow: "0px 0px 10px 0px rgba(0, 0, 0, 0.15)",
  borderRadius: theme.radius.medium,
  margin: `${theme.space.large} auto`,
  "@media screen and (min-width: 800px)": {
    flexDirection: "row",
  },
});

export const MainContent = styled.div({
  display: "flex",
  flexDirection: "column",
  padding: `${theme.space.small} ${theme.space.medium}`,
  flex: "3",
  "@media screen and (min-width: 800px)": {
    padding: `${theme.space.small} ${theme.space.medium}`,
  },
});

export const SecondaryContent = styled(MainContent)({
  flex: "2",
  backgroundColor: theme.color.lightGray,
  borderRadius: theme.radius.medium,
  boxShadow: "0px 0px 10px 0px rgba(0, 0, 0, 0.15)",
  borderTop: `1px solid ${theme.color.darkGray}`,
  "@media screen and (min-width: 800px)": {
    borderTop: "none",
    borderLeft: `1px solid ${theme.color.darkGray}`,
  },
});

export const Row = styled.div<{ disabled?: boolean }>(
  ({ disabled = false }) => ({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    borderRadius: theme.radius.small,
    padding: `${theme.space.tiny} 0`,
    margin: `0 0 ${theme.space.nano} 0`,
    backgroundColor: disabled ? theme.color.lightGray : "transparent",
    "& ~ &": {
      margin: `${theme.space.tiny} 0 ${theme.space.nano} 0`,
    },
    "@media screen and (min-width: 800px)": {
      margin: `0 0 ${theme.space.tiny} 0`,
      "& ~ &": {
        margin: `${theme.space.small} 0 ${theme.space.tiny} 0`,
      },
    },
  })
);

export const Label = styled.label<{ $result?: boolean }>(
  ({ $result = false }) => ({
    display: "inline-flex",
    alignItems: "baseline",
    flexWrap: "wrap",
    fontWeight: "bold",
    textAlign: "left",
    fontSize: theme.fontSize.default,
    marginBottom: theme.space.nano,
    ...($result && {
      fontWeight: "normal",
      alignSelf: "center",
      marginBottom: theme.space.nano,
      textTransform: "uppercase",
      textAlign: "center",
      color: theme.color.lightBlack,
      fontSize: theme.fontSize.small,
    }),
  })
);

export const InputRow = styled.div({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "space-between",
  width: "100%",
  marginBottom: theme.space.small,
});

export const InputRowGroup = styled.div({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
});

export const UnitInputLabel = styled.span({
  justifySelf: "flex-end",
  fontSize: theme.fontSize.default,
  marginLeft: theme.space.tiny,
  "@media screen and (min-width: 800px)": {
    fontSize: theme.fontSize.inbetween,
  },
});
